import { slice } from '../slices';

const nameSpace = slice.name;

export const isActiveSelector = (state) => state[nameSpace].isActive;
export const isSelectedAllSelector = (state) => state[nameSpace].isSelectedAll;
export const videoIdsSelector = (state) => state[nameSpace].videoIds;
export const excludeVideoIdsSelector = (state) => state[nameSpace].excludeVideoIds;

export const monitoringIdsSelector = (state) => state[nameSpace].monitoringIds;
export const monitoringStateSelector = (state) => state[nameSpace].monitoringState;

export const hubOptionsSelector = (state) => state[nameSpace].hubOptions;

export const advertiserOptionsSelector = (state) => state[nameSpace].advertiserOptions;

// computed
export const isVideoSelectedSelector = (videoId, state) => videoIdsSelector(state).includes(videoId);
